import React from "react";
import CardIcon from "../../../assets/img/payment/master.svg";
import Applepay from "../../../assets/img/payment/Applepay.svg";
import Googlepay from "../../../assets/img/payment/Googlepay.svg";
import Afterpay from "../../../assets/img/payment/Afterpay.svg";
import ZipPay from "../../../assets/img/payment/zippay.svg";
import klarna from "../../../assets/img/payment/klarna.svg";
import PayID from "../../../assets/img/payment/payid.svg";
import Bank from "../../../assets/img/payment/banktransfer.svg";
import Cash from "../../../assets/img/payment/cash.svg";
import PaymentComp from "../../../sections/BusinessDashboard/Settings/PaymentComp";
import { AdminPageTitle } from "../../../sections/AdminDashboard/shared/adminUx";
import DashboardMainContainer from "../../../components/common/Containers/DashboardMainContainer";
import { BUSINESS_CENTERED_PAGE_TITLE_CLASS } from "../../../sections/BusinessDashboard/shared/businessLayoutSpec";

const Payment = () => {
  const paymentMethods = [
    { method: "Card", image: CardIcon, status: "Add" },
    { method: "Apple Pay", image: Applepay, status: "Add" },
    { method: "Google Pay", image: Googlepay, status: "Add" },
    { method: "Afterpay", image: Afterpay, status: "Add" },
    { method: "Zip", image: ZipPay, status: "Add" },
    { method: "Klarna", image: klarna, status: "Add" },
    { method: "PayID", image: PayID, status: "Add" },
    { method: "Bank Transfer", image: Bank, status: "Add" },
    { method: "Cash", image: Cash, status: "Add" },
  ];
  return (
    <DashboardMainContainer className="lg:px-5 lg:pb-10">
      <AdminPageTitle className={`text-offblack ${BUSINESS_CENTERED_PAGE_TITLE_CLASS}`}>
        Payment options
      </AdminPageTitle>
      <div className="min-h-screen">
        <div className="grid grid-cols-2 xs:grid-cols-3 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-6 2xl:grid-cols-7 justify-between mx-[5%] lg:mx-auto md:w-[600px] lg:w-[680px] xl:w-[1000px] 2xl:w-[1200px] gap-y-16">
          {paymentMethods?.map((item, index) => {
            return (
              <PaymentComp
                key={index}
                method={item.method}
                image={item.image}
                status={item.status}
              />
            );
          })}
        </div>
      </div>
    </DashboardMainContainer>
  );
};

export default Payment;
